import { isDue } from '../services/sm2.js';

// Matches desktop's RecallParsing.swift / recall-parsing.js CLOZE_RE.
const CLOZE_RE = /\{\{([^{}\n]*?)\}\}(\^c-([a-z0-9]{6}))?/g;

function extractDueCards(notes) {
  const cards = [];
  notes.forEach(note => {
    const text = note.content || '';
    CLOZE_RE.lastIndex = 0;
    let m;
    while ((m = CLOZE_RE.exec(text)) !== null) {
      if (!m[1] || !m[1].trim()) continue;
      const cardId = m[3] || null;
      const state = cardId ? (note.cardStates || {})[cardId] : null;
      if (!isDue(state)) continue;
      cards.push({
        noteId: note.id,
        cardId,
        context: text.slice(0, m.index) + '【 ??? 】' + text.slice(m.index + m[0].length),
        answer: m[1]
      });
    }
  });
  return cards;
}

export function renderFlashcardReviewModal(container, { isOpen, notes, onClose, onGrade }) {
  if (!isOpen) {
    container.innerHTML = '';
    return;
  }

  const cards = extractDueCards(notes);
  let currentCardIdx = 0;
  let isAnswerRevealed = false;

  const renderCard = () => {
    if (cards.length === 0) {
      container.innerHTML = `
        <div class="sheet-backdrop open" id="flash-backdrop"></div>
        <div class="sheet-modal open" style="top: 15%; padding: 24px; text-align: center;">
          <div class="sheet-header" style="border: none;">
            <span class="sheet-title">Recall Review 🧠</span>
          </div>
          <p style="color: var(--ink-secondary); margin: 30px 0;">No cards due right now.<br><br>Add <code>{{term}}</code> to a note to create a spaced-repetition flashcard!</p>
          <button class="chip-btn" id="btn-close-flash" style="background: var(--signal-blue); color: white; margin: 0 auto; width: 120px;">Done</button>
        </div>
      `;
      const backdrop = container.querySelector('#flash-backdrop');
      if (backdrop) backdrop.onclick = onClose;
      const closeBtn = container.querySelector('#btn-close-flash');
      if (closeBtn) closeBtn.onclick = onClose;
      return;
    }

    const card = cards[currentCardIdx];

    container.innerHTML = `
      <div class="sheet-backdrop open" id="flash-backdrop"></div>
      <div class="sheet-modal open" style="top: 10%; padding: 20px;">
        <div class="sheet-handle-bar"></div>
        <div class="sheet-header">
          <div class="sheet-top-row">
            <span class="sheet-title">Recall Review (${currentCardIdx + 1}/${cards.length}) 🧠</span>
            <button class="icon-btn" id="btn-close-flash">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
          </div>
        </div>

        <div style="flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 16px 0;">
          <div class="flashcard-card" id="flashcard-box">
            <div style="font-size: 17px; line-height: 1.6; color: var(--ink-primary);">
              ${escapeHtml(card.context)}
            </div>
            ${isAnswerRevealed ? `
              <div style="margin-top: 20px; font-size: 22px; font-weight: 700; color: var(--signal-blue); border-top: 1px solid var(--ink-faint); padding-top: 12px; width: 100%;">
                ${escapeHtml(card.answer)}
              </div>
            ` : ''}
          </div>

          ${!isAnswerRevealed ? `
            <button class="chip-btn" id="btn-reveal-answer" style="background: var(--signal-blue); color: white; width: 100%; height: 48px; font-size: 16px; font-weight: 700;">Show Answer</button>
          ` : `
            <div class="flashcard-actions">
              <button class="sm2-btn sm2-again" data-grade="again">Again</button>
              <button class="sm2-btn sm2-hard" data-grade="hard">Hard</button>
              <button class="sm2-btn sm2-good" data-grade="good">Good</button>
              <button class="sm2-btn sm2-easy" data-grade="easy">Easy</button>
            </div>
          `}
        </div>
      </div>
    `;

    const backdrop = container.querySelector('#flash-backdrop');
    if (backdrop) backdrop.onclick = onClose;

    const closeBtn = container.querySelector('#btn-close-flash');
    if (closeBtn) closeBtn.onclick = onClose;

    const revealBtn = container.querySelector('#btn-reveal-answer');
    if (revealBtn) {
      revealBtn.onclick = () => {
        isAnswerRevealed = true;
        renderCard();
      };
    }

    container.querySelectorAll('[data-grade]').forEach(btn => {
      btn.onclick = () => {
        if (navigator.vibrate) navigator.vibrate(10);
        if (card.cardId && onGrade) onGrade(card.noteId, card.cardId, btn.dataset.grade);
        cards.splice(currentCardIdx, 1);
        if (currentCardIdx >= cards.length) currentCardIdx = 0;
        isAnswerRevealed = false;
        renderCard();
      };
    });
  };

  renderCard();
}

function escapeHtml(str) {
  return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
